"use client";
import { UseCaseOutcome } from "@/types/global";
import Image from "next/image";

interface OutcomesProps {
    title: string;
    description: string;
    items: UseCaseOutcome[];
}

const Outcomes = ({ title, description, items }: OutcomesProps) => {
    return (
        <section className="desilo-about2-section bg-color-white ">
            <div className="container custom-container">
                <div className="row align-items-stretch">
                    <div className="col-xl-6">
                        <div className="desilo-about2__thumb overflow-hidden pe-xl-4 h-100">
                            <Image
                                className="w-100 object-fit-cover"
                                height={400}
                                width={100}
                                sizes="100vw"
                                src="/images/use-case/outcomes.webp"
                                alt="Desilo team is brainstorming and mapping business strategies to build impactful products."
                            />
                        </div>
                    </div>
                    <div className="col-xl-6 gsap-scroll row-margin-top2">
                        <div className="desilo-about2__content ps-xl-4 position-sticky sticky-col">
                            <h2>
                                {title}
                            </h2>
                            <p className="mt-3 mt-lg-4">
                                {description}
                            </p>
                            <div className="row row-padding-top">
                                {items.map((item, index) => (
                                    <div key={index} className="col-6 d-flex align-items-start gap-3 g-4">
                                        <i className={`${item.icon} mt-2`} ></i>
                                        <p className="">{item.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Outcomes;
